/**
 * G14. Что оставить: шесть «наследств», каждое — детям или когорте
 * (без детей — только когорте, выбор не нужен). «На пенсию» закрывает
 * решение, «Работать дальше» — остаться.
 */
import { t } from '@life/i18n';
import type { LegacyInput, LegacyState } from '@life/minigames';
import { useState } from 'preact/hooks';
import type { MinigameScreenProps } from './types';
import { Choice } from './ui/Choice';

export function Legacy({ state, onInput }: MinigameScreenProps<LegacyInput, LegacyState>) {
  const single = state.recipients.length <= 1;
  const [to, setTo] = useState<(number | null)[]>(() => state.items.map(() => (single ? 0 : null)));
  const complete = to.every((r) => r !== null);
  const recipientLabels = state.recipients.map((r) => t(`minigame.legacy.to.${r}`));

  return (
    <>
      <p class="hint">{single ? t('ui.minigame.legacy.rules.single', { to: recipientLabels[0] ?? '' }) : t('ui.minigame.legacy.rules')}</p>
      {state.items.map((item, i) => (
        <div class="q row" key={item.id} data-question={i}>
          <p class="q-text">{t(item.key)}</p>
          {!single && <Choice label={t(item.key)} items={recipientLabels.map((text) => ({ text }))} value={to[i] ?? null} onChange={(j) => setTo(to.map((r, k) => (k === i ? j : r)))} />}
        </div>
      ))}
      <div class="picks">
        <button type="button" class="btn accent" disabled={!complete} onClick={() => onInput({ to: to.map((r) => r ?? 0) })}>
          {t('ui.minigame.legacy.retire')}
        </button>
        <button type="button" class="btn" onClick={() => onInput({ to: [], stay: true })}>
          {t('ui.minigame.legacy.stay')}
        </button>
      </div>
    </>
  );
}
